/**
 * @generated SignedSource<<031585e1ecc11fa948c72bcd8c7d5ac9>>
 * @relayHash ed11a2eac6dca17d8aaade2074e9ee82
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b10c54acd88b396d0f54bdd62132a9b7528cc458742767c7d404b9459c86c225

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFavouriteType = "BOARD" | "DASHBOARD" | "FILTER" | "JPD_COLLECTION" | "PLAN" | "PROJECT" | "QUEUE" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraFavouriteFilter = {
  includeArchivedProjects?: boolean | null;
  keyword?: string | null;
  sort?: JiraFavouriteSortInput | null;
  type?: JiraFavouriteType | null;
  types?: ReadonlyArray<JiraFavouriteType> | null;
};
export type JiraFavouriteSortInput = {
  order: SortDirection;
};
export type StarredMenuQuery$variables = {
  cloudId: string;
  count: number;
  filter: JiraFavouriteFilter;
};
export type StarredMenuQuery$data = {
  readonly jira: {
    readonly allFavourites: {
      readonly pageInfo: {
        readonly startCursor: string | null;
      };
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"StarredMenu">;
};
export type StarredMenuQuery = {
  response: StarredMenuQuery$data;
  variables: StarredMenuQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": isJpdRoadmapsRecentsEnabled_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled: {
    readonly get: () => boolean;
  };
});

import isJpdRoadmapsRecentsEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJpdRoadmapsRecentsEnabled';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v5 = [
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v6 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "startCursor"
    }
  ]
},
v7 = [
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v12 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNode"
},
v13 = [
  (v9/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      {
        "kind": "ScalarField",
        "name": "filterUrl"
      },
      {
        "kind": "ScalarField",
        "name": "filterId"
      },
      (v12/*: any*/)
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "title"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StarredMenuQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "alias": "allFavourites",
              "args": (v5/*: any*/),
              "concreteType": "JiraFavouriteConnection",
              "kind": "LinkedField",
              "name": "favourites",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v6/*: any*/),
                  "action": "THROW"
                }
              ]
            }
          ]
        },
        "action": "THROW"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          }
        ],
        "kind": "FragmentSpread",
        "name": "StarredMenu"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
      }
    ],
    "kind": "Operation",
    "name": "StarredMenuQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "allFavourites",
            "args": (v5/*: any*/),
            "concreteType": "JiraFavouriteConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ]
          },
          {
            "alias": "starredItems",
            "args": (v7/*: any*/),
            "concreteType": "JiraFavouriteConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraFavouriteEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "projectId"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "defaultNavigationItem",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "JiraNavigationItem",
                                "abstractKey": "__isJiraNavigationItem"
                              },
                              (v11/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "large"
                              }
                            ]
                          },
                          (v12/*: any*/)
                        ],
                        "type": "JiraProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v13/*: any*/),
                        "type": "JiraSystemFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v13/*: any*/),
                        "type": "JiraCustomFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "dashboardUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                          },
                          (v12/*: any*/)
                        ],
                        "type": "JiraDashboard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "planUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "planId"
                          },
                          (v12/*: any*/)
                        ],
                        "type": "JiraPlan"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": "title",
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "boardUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "boardId"
                          },
                          (v12/*: any*/)
                        ],
                        "type": "JiraBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v9/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "queueUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "queueId"
                          },
                          (v12/*: any*/)
                        ],
                        "type": "JiraServiceManagementQueue"
                      },
                      {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v9/*: any*/),
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "collectionId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "emoji"
                              },
                              (v12/*: any*/)
                            ],
                            "type": "JiraProductDiscoveryCollection"
                          }
                        ]
                      },
                      (v11/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              }
            ]
          },
          {
            "alias": "starredItems",
            "args": (v7/*: any*/),
            "filters": [
              "cloudId",
              "filter"
            ],
            "handle": "connection",
            "key": "StarredMenuListContent_starredItems",
            "kind": "LinkedHandle",
            "name": "favourites"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b10c54acd88b396d0f54bdd62132a9b7528cc458742767c7d404b9459c86c225",
    "metadata": {},
    "name": "StarredMenuQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled": isJpdRoadmapsRecentsEnabled_provider
    }
  }
};
})();

(node as any).hash = "fe54dd259a64768769310002e3616b4c";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
